<div class="popup-footer">

    <app-button class="button-footer" [text]="'Cancelar'" (buttonEvent)="close()" type="secondary"></app-button>
    <app-button class="button-footer" [text]="'Salvar'" (buttonEvent)="save()" type="primary" [disabled]="disabledButton"></app-button>

</div>
